import React, { useState } from 'react';
import { Input, Button } from '../UI';
import { evaluateGrowth } from '../../helpers/growthEvaluation';
import { calculateAgeMonths } from '../../helpers/utils';

export default function PertumbuhanForm({ onSave, child }) {
    const [bb, setBb] = useState('');
    const [tb, setTb] = useState('');
    const [lk, setLk] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        
        const weight = parseFloat(bb);
        const height = parseFloat(tb);
        const headCirc = parseFloat(lk);
        const ageInMonths = calculateAgeMonths(child.dob.toDate());
        const gender = child.gender || 'male'; // Default to male if not specified
        
        // Use the new growth evaluation system
        const growthEvaluation = evaluateGrowth(weight, height, headCirc, ageInMonths, gender);
        
        // Create detailed results
        const status = growthEvaluation.overall.status;
        const interpretasi = `
Berat Badan: ${growthEvaluation.weight.status} (${growthEvaluation.weight.interpretation})
Tinggi Badan: ${growthEvaluation.height.status} (${growthEvaluation.height.interpretation})
Lingkar Kepala: ${growthEvaluation.headCircumference.status} (${growthEvaluation.headCircumference.interpretation})

Status Keseluruhan: ${growthEvaluation.overall.status}
        `.trim();
        
        const rekomendasi = `
Rekomendasi Berat Badan: ${growthEvaluation.weight.recommendation}
Rekomendasi Tinggi Badan: ${growthEvaluation.height.recommendation}
Rekomendasi Lingkar Kepala: ${growthEvaluation.headCircumference.recommendation}

Rekomendasi Umum: ${growthEvaluation.overall.recommendation}
        `.trim();
        
        const detail = `
BB: ${bb}kg (Z-Score: ${growthEvaluation.weight.zScore || 'N/A'})
TB: ${tb}cm (Deviasi: ${growthEvaluation.height.deviation || 'N/A'}%)
LK: ${lk}cm (Deviasi: ${growthEvaluation.headCircumference.deviation || 'N/A'}%)
Usia: ${ageInMonths} bulan
        `.trim();
        
        const data = { 
            pertumbuhan: { 
                bb, 
                tb, 
                lk, 
                status, 
                interpretasi, 
                rekomendasi,
                detail,
                evaluationData: growthEvaluation
            } 
        };
        
        onSave(data, status);
        // setLoading(false) will be handled by the parent component after Firestore save.
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="bg-blue-50 p-4 rounded-lg mb-4">
                <h4 className="font-semibold text-blue-800 mb-2">Petunjuk Pengukuran</h4>
                <ul className="text-sm text-blue-700 space-y-1">
                    <li>• Berat badan: Timbang tanpa pakaian atau pakaian minimal</li>
                    <li>• Tinggi badan: Ukur dalam posisi berdiri tegak (atau berbaring untuk bayi)</li>
                    <li>• Lingkar kepala: Ukur bagian terlebar kepala dengan pita ukur</li>
                </ul>
            </div>
            
            <Input 
                label="Berat Badan (kg)" 
                type="number" 
                step="0.1" 
                min="0.5" 
                max="50" 
                value={bb} 
                onChange={e => setBb(e.target.value)} 
                required 
                placeholder="Contoh: 12.5"
            />
            <Input 
                label="Tinggi Badan (cm)" 
                type="number" 
                step="0.1" 
                min="30" 
                max="200" 
                value={tb} 
                onChange={e => setTb(e.target.value)} 
                required 
                placeholder="Contoh: 85.0"
            />
            <Input 
                label="Lingkar Kepala (cm)" 
                type="number" 
                step="0.1" 
                min="25" 
                max="65" 
                value={lk} 
                onChange={e => setLk(e.target.value)} 
                required 
                placeholder="Contoh: 48.5"
            />
            <Button type="submit" disabled={loading}>{loading ? 'Menyimpan...' : 'Simpan Hasil Pertumbuhan'}</Button>
        </form>
    );
}
